<template>
    <div class="">
        <div>
            <ol class="breadcrumb fs-sm mb-1">
                <li class="breadcrumb-item">
                    <router-link to="/dashboard">Dashboard</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Categories</li>
            </ol>
            <h4 class="main-title mb-2">Categories</h4>
        </div>
        <div class="row">
            <div class="col-4" v-can="'category.create'">
                <form @submit.prevent="submitForm()">
                    <div class="card card-one">
                        <div class="card-header d-flex justify-content-between">
                            <h6 class="card-title" v-if="status">Add Category</h6>
                            <h6 class="card-title" v-else>Update Category</h6>
                        </div>
                        <div class="card-body">
                            <div class="row g-2">
                                <div class="col-md-12">
                                    <label class="form-label">Category Name</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Category Name" class="form-control" :class="{ 'is-invalid': errors.category_name }" v-model="category.category_name" ref="category_name" />
                                    <span v-if="errors.category_name"><small class="text-danger">{{ errors.category_name[0] }}</small></span>
                                </div>
                                <div class="col-md-12">
                                    <label class="form-label">Description</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Description" class="form-control" :class="{ 'is-invalid': errors.description }" v-model="category.description" />
                                    <span v-if="errors.description"><small class="text-danger">{{ errors.description[0] }}</small></span>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer text-end">
                            <button type="button" class="btn btn-danger me-2" @click="discard()"><i class="ri-close-line fs-18 lh-1"></i> Back</button>
                            <button type="submit" class="btn btn-primary" >
                                <span v-if="status"><i class="ri-save-line fs-18 lh-1"></i> Submit</span>
                                <span v-else><i class="ri-save-line fs-18 lh-1"></i> Update</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div :class="column">
                <div class="card card-one">
                    <div class="card-header d-flex justify-content-between">
                        <h6 class="card-title">Categories</h6>
                    </div>
                    <div class="card-body">
                        <input class="form-control mb-2" type="text" placeholder="Type keyword and press enter key" v-model="meta.search" @keypress.enter="search()" />
                        <div class="table-responsive table-responsive-sm">
                            <table class="table table-sm table-striped text-nowrap table-bordered mb-0">
                                <thead>
                                    <tr style="background-color: #9b9b9b; color: white;">
                                        <th class="text-center">#</th>
                                        <th @click="sort('category_name')">Category Name
                                            <span>
                                                <i v-if="meta.keyword=='category_name' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword=='category_name' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span></th>
                                        <th @click="sort('description')">Description
                                        
                                            <span>
                                                <i v-if="meta.keyword=='description' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword=='description' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span></th>
                                       
                                        <th class="text-center" v-can="'category.delete'">Status</th>
                                        <th class="text-center" v-can="'category.update'">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="categories.length==0">
                                        <td colspan="6" class="text-center">No records found</td>
                                    </tr>
                                    <tr v-for="category, key in categories" :key="key">
                                        <td class="text-center">{{ meta.from + key }}</td>
                                        <td>{{category.category_name}}</td>
                                        <td>{{ category.description }}</td>
                                        <td class="text-center" v-can="'category.delete'">
                                            <div class="form-switch">
                                                <input class="form-check-input" type="checkbox" role="switch" :id="'category' + category.category_id" :checked="category.status" :value="category.status" @change="deleteCategory(category)" />
                                                <label class="custom-control-label" :for="'category' + category.category_id"></label>
                                            </div>
                                        </td>
                                        <td class="text-center" v-can="'category.update'">
                                            <a href="javascript:void(0)" v-if="category.status" class="text-success me-2" @click="editCategory(category)"><i class="ri-pencil-line fs-18 lh-1"></i></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="d-flex justify-content-between align-items-center">
                            <select class="form-select from-select-sm width-75" v-model="meta.per_page" @change="onPerPageChange">
                                <option>10</option>
                                <option>15</option>
                                <option>20</option>
                                <option>25</option>
                                <option>30</option>
                            </select>
                            <span>Showing {{ meta.from }} to {{ meta.to }} of {{ meta.totalRows }} entries</span>

                            <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination.vue";
    export default {
        components: {
            Pagination,
        },
        data() {
            return {
                column: 'col-8',
                meta: {
                    search: "",
                    order_by: "asc",
                    keyword: "category_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    trashed: false,
                },
                category: {
                    category_id: "",
                    category_name: "",
                    description: "",
                },
                status: true,
                categories: [],
                errors: [],
            };
        },
        mounted() {
            this.create_category = this.$store.getters.permissions.filter(function(element){
                return element.ability.ability.includes('category.create')
            })
            if(this.create_category.length){
                this.column = 'col-8'
            }else{
                this.column = 'col-12'
            }
            this.index();
        },

        methods: {
            submitForm() {
                let vm = this;
                if (vm.status) {
                    vm.addCategory();
                } else {
                    vm.updateCategory();
                }
            },
            index() {
                let vm = this;
                vm.$store
                    .dispatch("post", { uri: "paginateCategories", data: vm.meta })
                    .then((response) => {

                        vm.categories = response.data.data;
                        vm.meta.totalRows = response.data.meta.total;
                        vm.meta.lastPage = response.data.meta.last_page;
                        vm.meta.from = response.data.meta.from;
                        vm.meta.to = response.data.meta.to;
                        vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            addCategory() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "addCategory", data: vm.category })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", "Category Added successfully");
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            updateCategory() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "updateCategory", data: vm.category })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", "Category is successfully updated");
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            editCategory(category) {
                let vm = this;
                vm.$refs.category_name.focus();
                vm.errors = [];
                vm.status = false;
                vm.category = category;
            },

            deleteCategory(category) {
                let vm = this;
                let loader = vm.$loading.show();
                category.status = category.status == 1 ? 0 : 1;
                vm.$store
                    .dispatch("post", { uri: "deleteCategory", data: category })
                    .then(function (response) {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            search() {
                let vm = this;
                vm.meta.page = 1;
                vm.index();
            },

            onPageChange(page) {
                let vm = this;
                vm.meta.page = page;
                vm.index();
            },
            sort(field) {
                let vm = this;
                vm.meta.keyword = field;
                vm.meta.order_by = vm.meta.order_by == "asc" ? "desc" : "asc";
                vm.index();
            },
            discard() {
                let vm = this;
                vm.category.category_name = "";
                vm.category.description = "";
                vm.$refs.category_name.focus();
                vm.errors = [];
                vm.status = true;
                vm.index();
            },
            onPerPageChange() {
                this.meta.page = 1;
                this.index();
            },
            
        },
    };
</script>
